export const getLocation = async (): Promise<{ latitude: number; longitude: number }> => {
    try {
        const position = await new Promise<any>((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        });

        const location = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
        }

        console.log('got location: ', location)

        return location;
    } catch (err) {
        console.error(`Location error - ${err?.message}`)
        return {
            latitude: null,
            longitude: null
        };
    }
};
